import { render, staticRenderFns } from "./Areportable.vue?vue&type=template&id=10bd5aa3"
import script from "./Areportable.vue?vue&type=script&lang=js"
export * from "./Areportable.vue?vue&type=script&lang=js"
import style0 from "./Areportable.vue?vue&type=style&index=0&id=10bd5aa3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports